module.exports = __webpack_public_path__ + "img/visa_mastercard_meeza.90023ebe.png";